/*
 * @Date: 2023-11-07 15:07:46
 * @LastEditors: lihwang
 * @LastEditTime: 2023-11-09 18:16:42
 * @FilePath: /ckb-mall-web/src/container/home/index.tsx
 * @Description:
 * @Author: lihwang
 */
import React, { useRef, useState } from 'react';
import { useAsyncEffect, useScroll } from 'ahooks';
import { request } from '@/config/request';
import Search from '@/common/CKBLayout/modules/Search';
import OrderCancelModal from '@/common/CKBLayout/modules/OrderCancelModal';
import HomeModal from '@/common/CKBLayout/modules/HomeModal';
import BackTop from '@/components/BackTop';
import { BannerRespDTO } from '@/service/market';
import NoticeBanner from './modules/NoticeBanner';
import ActivityBanner from './modules/ActivityBanner';
import GoodsBanner from './modules/GoodsBanner';
import ActivePlate from './modules/ActivePlate';
import RecommendPlate from './modules/RecommendPlate';
import styles from './index.module.scss';
enum PlaceTypes {
    Notice = 1,
    Activity_banner = 2,
    Goods_Banner = 3
}
const Home = () => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [positionImages, setPositionImages] = useState<BannerRespDTO[]>([]);
    useAsyncEffect(async () => {
        const res = await request.market.banner.show({
            sourceChannel: '1',
            bizScene: '1'
        });
        setPositionImages(res.data as BannerRespDTO[]);
    }, []);
    const goodsBanners = positionImages.filter(
        (item) => item.placeType === PlaceTypes.Goods_Banner
    );
    const scroll = useScroll();
    return (
        <div ref={containerRef} className={styles.container}>
            <OrderCancelModal />
            <HomeModal />
            <Search />
            <NoticeBanner
                noticeBannerData={positionImages.filter(
                    (item) => item.placeType === PlaceTypes.Notice
                )}
            />
            <ActivityBanner
                activityData={positionImages.filter(
                    (item) => item.placeType === PlaceTypes.Activity_banner
                )}
            />
            {/** 小于四个不展示 */}
            {goodsBanners.length >= 4 && (
                <GoodsBanner goodsData={goodsBanners} />
            )}
            <ActivePlate />
            <RecommendPlate />
            {(scroll?.top || 0) > window.innerHeight && (
                <BackTop containerRef={containerRef} />
            )}
        </div>
    );
};
export default Home;
